module.exports = __webpack_public_path__ + "media/images/articles/interview/cover-09b948cc700c6277dac9f72d36bf34dd.png";